<template>
</template>
<script>
import util from '../../libs/util'
export default {
  name: 'ie-warning',
  created() {
    this.showIeWarning()
  },
  methods: {
    showIeWarning() {
      let ieWarning = localStorage.getItem('ie_warning')
      if (util.isIe() && (!ieWarning || ieWarning === '0')) {
        this.$notify.warning({
          title: '平台提示',
          // ie浏览器多行文字notify样式有问题，增加width解决
          message: '<div style="width: 244px">IE浏览器官方已停止更新维护,可能会对您在平台的功能使用造成不好的体验,推荐使用谷歌浏览器访问！</div>',
          dangerouslyUseHTMLString: true
        })
        localStorage.setItem('ie_warning', '1')
      }
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/components/ie-warning/ie-warning.vue